import { useAppSelector } from '@hooks/app/redux';
import { memberApiV2 } from '@lib/api';
import { AsyncSelect, AsyncSelectProps } from '../../ui/inputs/select';
import React from 'react';
import { useIntl } from 'react-intl';
import { OptionTypeBase } from 'react-select';

interface InstitutionsSelectProps
  extends Omit<
    AsyncSelectProps<OptionTypeBase, false>,
    'loadOptions' | 'placeholder' | 'isMulti' | 'cacheOptions' | 'defaultOptions'
  > {}

const InstitutionsSelect: React.FunctionComponent<InstitutionsSelectProps> = (props) => {
  const { formatMessage } = useIntl();
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  const institutionOpts = React.useCallback(
    async (query: string) => {
      const institutions = (
        await memberApiV2.searchInstitutions(providerId as string, {
          page: 1,
          pageSize: 30,
          sortBy: 'name',
          direction: 'ASC',
          name: query,
        })
      ).data;

      return institutions.data.items.map((e: any) => ({
        value: e.id,
        label: e.name,
      }));
    },
    [providerId],
  );

  return (
    <AsyncSelect
      loadOptions={institutionOpts}
      isMulti={false}
      cacheOptions
      defaultOptions
      placeholder={formatMessage({ id: 'rs_placeholder' })}
      {...props}
    />
  );
};

export default InstitutionsSelect;
